import Drawable from '../entities/Drawable.js';

import { spriteStore } from '../images.js';

export default class TypeBadge extends Drawable {
    constructor({ type, position = { x: 0, y: 0 }, visible = true }) {
        super();
        this.type = type;
        this.position = position;
        this.visible = visible;
        this.sprites = { typeBadge: spriteStore.store.typeBadge };
    }

    draw() {
        if (!this.visible) {
            return;
        }

        this.sprites.typeBadge.frames.val = {
            normal: 0,
            fight: 1,
            fighting: 1,
            flying: 2,
            poison: 3,
            ground: 4,
            rock: 5,
            bug: 6,
            ghost: 7,
            steel: 8,
            unknown: 9,
            fire: 10,
            water: 11,
            grass: 12,
            electric: 13,
            psychic: 14,
            ice: 15,
            dragon: 16,
            dark: 17,
            blank: 18,
        }[this.type];

        // TODO: Calculate frame val
        this.sprites.typeBadge.position.x = this.position.x;
        this.sprites.typeBadge.position.y = this.position.y;
        this.sprites.typeBadge.draw();
    }
}
